export const isOfflinePackage = Boolean(process.env.REACT_APP_IS_OFFLINE_PACKAGE);
